import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { CDN_TYPE_CMS, imageUrlCDN } from 'utils';

import { SiteConfigManager, useBlog, useSettings } from '@atlas/core';
import { COMPONENT_TYPES } from '@atlas/routing';
import { Icon, Loader } from '@atlas/ui';

import SeoPageText from 'components/SeoPage/SeoPageText';

const { BLOG } = COMPONENT_TYPES;

const Blog = () => {
  const [DOMPurify, installDOMPurify] = useState({});
  const { id } = useParams();
  const { lang } = useSettings();
  const { getBlogElement, isLoading, reset, selectedBlog } = useBlog();

  const blogPath = SiteConfigManager.getComponentPath(BLOG);

  useEffect(() => {
    import('dompurify').then(DOMPurifyModule => {
      installDOMPurify({ ...DOMPurifyModule.default });
    });
  }, []);

  useEffect(() => {
    getBlogElement(Number(id), lang);
  }, [getBlogElement, id, lang]);

  useEffect(() => {
    return () => {
      reset();
    };
  }, [reset]);

  if (isLoading || !selectedBlog) return <Loader className="relative" />;

  const { full_content, mobile_cover_image_url, short_content, title } = selectedBlog;

  return (
    <div className="layout-to-scroll">
      <div className="blog_page single">
        <div className="blog">
          <div className="blog__item">
            <Link className="back-to-container ellipsis" to={blogPath}>
              <Icon className="icon-back" name="back" />
              <h1 className="title-text">{title}</h1>
            </Link>
            <div className="content static_page">
              <div className="imageWrapper">
                <img
                  alt=""
                  loading="lazy"
                  src={imageUrlCDN(mobile_cover_image_url, CDN_TYPE_CMS)}
                />
              </div>
              {!!DOMPurify.sanitize && (
                <>
                  <div
                    className="description short-content"
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(short_content, { KEEP_CONTENT: true }),
                    }}
                  />
                  <div
                    className="description"
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(full_content, { FORCE_BODY: true }),
                    }}
                  />
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      <SeoPageText />
    </div>
  );
};

export default Blog;
